import tags from '../tags';

const {
  offensivePassive,
  defensivePassive,
  resourcePassive,
  mobilityPassive,
  healingPassive,
  cooldownPassive,
} = tags.passives;

export default [
  {
    name: 'Life from Death',
    tags: [healingPassive],
  },
  {
    name: 'Fueled by Death',
    tags: [mobilityPassive],
  },
  {
    name: 'Stand Alone',
    tags: [defensivePassive],
  },
  {
    name: 'Bone Prison',
    tags: [offensivePassive],
  },
  {
    name: 'Swift Harvesting',
    tags: [offensivePassive],
  },
  {
    name: 'Commander of the Risen Dead',
    tags: [resourcePassive, cooldownPassive],
  },
  {
    name: 'Extended Servitude',
    tags: [mobilityPassive],
  },
  {
    name: 'Rigor Mortis',
    tags: [],
  },
  {
    name: 'Overwhelming Essence',
    tags: [resourcePassive],
  },
  {
    name: 'Dark Reaping',
    tags: [resourcePassive, healingPassive],
  },
  {
    name: 'Spreading Malediction',
    tags: [offensivePassive],
  },
  {
    name: 'Eternal Torment',
    tags: [resourcePassive],
  },
  {
    name: 'Final Service',
    tags: [healingPassive],
  },
  {
    name: 'Grisly Tribute',
    tags: [healingPassive],
  },
  {
    name: 'Draw Life',
    tags: [healingPassive],
  },
  {
    name: 'Serration',
    tags: [offensivePassive],
  },
  {
    name: 'Aberrant Animator',
    tags: [offensivePassive],
  },
  {
    name: 'Blood for Blood',
    tags: [resourcePassive],
  },
  {
    name: 'Blood is Power',
    tags: [cooldownPassive],
  },
  {
    name: "Rathma's Shield",
    tags: [defensivePassive],
  },
];
